import React from "react";
import TopBanner from "../../TopBanner";
import Navigator from "../../Navigator";
import ContactForm from "../../ContactForm";
import Footer from "../../Footer";
import OpenContactButton from "../../OpenContactButton";
import "./style.scss";

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showContactButton?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className = "",
  showContactButton = true,
}) => {
  return (
    <div className={`page-container ${className}`}>
      <header className="header" id="header">
        <TopBanner />
        <Navigator />
      </header>

      <main className="mainBody" id="mainBody">
        {children}
        <Footer />
      </main>

      {showContactButton && <OpenContactButton />}
      <ContactForm />
    </div>
  );
};

export default PageLayout;
